// extracted by mini-css-extract-plugin
export var wrap = "plan-module--wrap--1UPLC";
export var allPlan = "plan-module--allPlan--2q6Uj";
export var allPlan__pageTitle = "plan-module--allPlan__pageTitle--2PAP6";
export var allPlanImage = "plan-module--allPlanImage--GmFdB";
export var planWrap = "plan-module--planWrap--1OuiN";
export var planWrap__blue = "plan-module--planWrap__blue--3tZmH";